var map = {
	"./baac.png": 196,
	"./bank.png": 113,
	"./bay.png": 197,
	"./bbl.png": 198,
	"./bnp.png": 199,
	"./boa.png": 200,
	"./cacib.png": 201,
	"./cimb.png": 202,
	"./citi.png": 203,
	"./db.png": 204,
	"./ghb.png": 205,
	"./gsb.png": 206,
	"./hsbc.png": 207,
	"./ibank.png": 208,
	"./icbc.png": 209,
	"./jpm.png": 210,
	"./kbank.png": 211,
	"./kkp.png": 212,
	"./ktb.png": 213,
	"./lhbank.png": 214,
	"./mb.png": 215,
	"./mega.png": 216,
	"./mufg.png": 217,
	"./promptpay.png": 218,
	"./rbs.png": 219,
	"./sc.png": 220,
	"./scb.png": 221,
	"./smbc.png": 222,
	"./tbank.png": 223,
	"./tcrb.png": 224,
	"./tisco.png": 225,
	"./tmb.png": 226,
	"./truewallet.png": 227,
	"./ttb.png": 228,
	"./uob.png": 229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 195;